export const COMPPOINTS = 'loyalty-points';

export const BALANCE_TYPES = {
    total: 'lifetime_loyalty_points_accrued',
    casino: 'casino_loyalty_balance',
    convert: 'loyalty_balance',
    bingo: 'bingo_loyalty_balance',
    sportsbook: 'sportsbook_loyalty_balance',
    poker: 'poker_loyalty_balance'
};
